var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "EditTable" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "tabel-warp"
        },
        [
          _c(
            "vxe-table",
            {
              ref: "vxeTable",
              attrs: {
                align: "center",
                border: "",
                data: _vm.tabelData,
                "column-config": _vm.columnConfig,
                "row-config": { isHover: true },
                round: "",
                size: "small",
                "tooltip-config": {
                  showAll: true
                },
                stripe: "",
                "edit-config": _vm.editConfig,
                "keep-source": "",
                "edit-rules": _vm.vxeRules,
                height: "100%"
              }
            },
            [
              _c("vxe-column", {
                attrs: {
                  field: "PO_NO",
                  title: _vm.$t("EditTable.PO_NO"),
                  "min-width": "200",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PO_NO,
                            callback: function($$v) {
                              _vm.$set(row, "PO_NO", $$v)
                            },
                            expression: "row.PO_NO"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PART_NO",
                  title: _vm.$t("EditTable.PART_NO"),
                  "min-width": "160",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PART_NO,
                            callback: function($$v) {
                              _vm.$set(row, "PART_NO", $$v)
                            },
                            expression: "row.PART_NO"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PART_NAME",
                  title: _vm.$t("EditTable.PART_NAME"),
                  "min-width": "200",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PART_NAME,
                            callback: function($$v) {
                              _vm.$set(row, "PART_NAME", $$v)
                            },
                            expression: "row.PART_NAME"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PART_DESCR",
                  title: _vm.$t("EditTable.PART_DESCR"),
                  "min-width": "180",
                  "show-overflow": "ellipsis",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PART_DESCR,
                            callback: function($$v) {
                              _vm.$set(row, "PART_DESCR", $$v)
                            },
                            expression: "row.PART_DESCR"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PO_REMAINING_QTY",
                  title: _vm.$t("EditTable.PO_REMAINING_QTY"),
                  "min-width": "120",
                  "edit-render": { enabled: _vm.canEdit }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PO_REMAINING_QTY,
                            callback: function($$v) {
                              _vm.$set(row, "PO_REMAINING_QTY", $$v)
                            },
                            expression: "row.PO_REMAINING_QTY"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "DELIVERY_QTY",
                  title: _vm.$t("EditTable.DELIVERY_QTY"),
                  "min-width": "130",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: false },
                          model: {
                            value: row.DELIVERY_QTY,
                            callback: function($$v) {
                              _vm.$set(row, "DELIVERY_QTY", $$v)
                            },
                            expression: "row.DELIVERY_QTY"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "SPQ",
                  title: _vm.$t("EditTable.SPQ"),
                  "min-width": "150",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: false },
                          model: {
                            value: row.SPQ,
                            callback: function($$v) {
                              _vm.$set(row, "SPQ", $$v)
                            },
                            expression: "row.SPQ"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PACKING_QTY",
                  title: _vm.$t("EditTable.PACKING_QTY"),
                  "min-width": "120",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: false },
                          model: {
                            value: row.PACKING_QTY,
                            callback: function($$v) {
                              _vm.$set(row, "PACKING_QTY", $$v)
                            },
                            expression: "row.PACKING_QTY"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "ATTRIBUTE1",
                  title: "采购单行号",
                  "min-width": "120",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: true },
                          model: {
                            value: row.ATTRIBUTE1,
                            callback: function($$v) {
                              _vm.$set(row, "ATTRIBUTE1", $$v)
                            },
                            expression: "row.ATTRIBUTE1"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "SUBINVENTORY_NAME",
                  title: _vm.$t("仓库"),
                  "min-width": "180",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: false },
                          model: {
                            value: row.SUBINVENTORY_NAME,
                            callback: function($$v) {
                              _vm.$set(row, "SUBINVENTORY_NAME", $$v)
                            },
                            expression: "row.SUBINVENTORY_NAME"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  formatter: _vm.vxeFormatDate,
                  field: "DATE_CODE",
                  title: _vm.$t("EditTable.DATE_CODE"),
                  "min-width": "150",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: {
                            type: "date",
                            placeholder: _vm.$t(
                              "EditTable.DATE_CODE-placeholder"
                            ),
                            transfer: ""
                          },
                          model: {
                            value: row.DATE_CODE,
                            callback: function($$v) {
                              _vm.$set(row, "DATE_CODE", $$v)
                            },
                            expression: "row.DATE_CODE"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "LOT_NO",
                  title: _vm.$t("EditTable.LOT_NO"),
                  "min-width": "130",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: false },
                          model: {
                            value: row.LOT_NO,
                            callback: function($$v) {
                              _vm.$set(row, "LOT_NO", $$v)
                            },
                            expression: "row.LOT_NO"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "ATTRIBUTE9",
                  title: _vm.$t("EditTable.ATTRIBUTE9"),
                  "min-width": "100",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "number", disabled: false },
                          model: {
                            value: row.ATTRIBUTE9,
                            callback: function($$v) {
                              _vm.$set(row, "ATTRIBUTE9", $$v)
                            },
                            expression: "row.ATTRIBUTE9"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "ATTRIBUTE8",
                  title: _vm.$t("EditTable.ATTRIBUTE8"),
                  "min-width": "100",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: false },
                          model: {
                            value: row.ATTRIBUTE8,
                            callback: function($$v) {
                              _vm.$set(row, "ATTRIBUTE8", $$v)
                            },
                            expression: "row.ATTRIBUTE8"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PO_UNIT",
                  title: _vm.$t("EditTable.PO_UNIT"),
                  "min-width": "100",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PO_UNIT,
                            callback: function($$v) {
                              _vm.$set(row, "PO_UNIT", $$v)
                            },
                            expression: "row.PO_UNIT"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "BASE_UNIT",
                  title: _vm.$t("EditTable.BASE_UNIT"),
                  "min-width": "100",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.BASE_UNIT,
                            callback: function($$v) {
                              _vm.$set(row, "BASE_UNIT", $$v)
                            },
                            expression: "row.BASE_UNIT"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "UNIT_EXRATE",
                  title: _vm.$t("EditTable.UNIT_EXRATE"),
                  "min-width": "130",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.UNIT_EXRATE,
                            callback: function($$v) {
                              _vm.$set(row, "UNIT_EXRATE", $$v)
                            },
                            expression: "row.UNIT_EXRATE"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "PO_TOTAL_QTY",
                  title: _vm.$t("EditTable.PO_TOTAL_QTY"),
                  "min-width": "120",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.PO_TOTAL_QTY,
                            callback: function($$v) {
                              _vm.$set(row, "PO_TOTAL_QTY", $$v)
                            },
                            expression: "row.PO_TOTAL_QTY"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "DESCRIPTION",
                  title: _vm.$t("EditTable.DESCRIPTION"),
                  "min-width": "200",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: false },
                          model: {
                            value: row.DESCRIPTION,
                            callback: function($$v) {
                              _vm.$set(row, "DESCRIPTION", $$v)
                            },
                            expression: "row.DESCRIPTION"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  field: "ATTRIBUTE1",
                  title: _vm.$t("EditTable.ATTRIBUTE1"),
                  "min-width": "100",
                  "edit-render": {
                    enabled: _vm.canEdit,
                    autofocus: ".vxe-input--inner"
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "edit",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("vxe-input", {
                          attrs: { type: "text", disabled: true },
                          model: {
                            value: row.ATTRIBUTE1,
                            callback: function($$v) {
                              _vm.$set(row, "ATTRIBUTE1", $$v)
                            },
                            expression: "row.ATTRIBUTE1"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm.isShowOptionColumn
                ? _c("vxe-column", {
                    attrs: {
                      field: "",
                      title: _vm.$t("EditTable.Option"),
                      "min-width": "100",
                      fixed: "right"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "cancellationButton",
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.hanldeDelete(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4157547706
                    )
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("addOrderRowDialog", {
        ref: "addOrderRowDialog",
        attrs: {
          isShowaddOutsourcedOrderRowDialog:
            _vm.isShowaddOutsourcedOrderRowDialog
        },
        on: {
          closeaddOrderRowDialog: _vm.closeaddOrderRowDialog,
          cbDialogSubmit: _vm.cbaddOrderRowDialogSubmit
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }